<template>
  <div>
    <div v-if="sortedRegions && sortedRegions.length > 0" class="tiles row pr-3 pl-3">
      <div v-for="(region, index) in sortedRegions" :key="region.id" :class="tileWrapperStyles(index)">
        <Tile
          :meta="`Last updated: ${lastUpdatedTimeAgo(region.id)}`"
          :content="region.dangerDescription"
          :styles="tileStyles(region)"
          :link="{ href: '#', title: `View full forecast for ${region.title}`, text: 'View full forecast' }"
          :clickable="true"
          :onClick="handleTileClick(region.id)">
          <div slot="image">
            <div class="tile__image-wrapper">
              <img
                v-if="region.image && expanded"
                class="tile__image hidden-md-down"
                :src="region.image"
                :alt="region.title" />
              <i v-if="showTileIcon(region)" class="tile__icon fa fa-exclamation" aria-hidden="true"></i>
            </div>
          </div>
          <div v-if="region.title" slot="title">
            <h3 class="tile__heading tile__heading--title">{{ region.title }}</h3>
            <RiskPill :rating="$store.getters.regionDangerRating(region.id).rating" />
            <p>{{ $store.getters.regionDangerRating(region.id).description }}</p>
          </div>
        </Tile>
      </div>
    </div>

    <div v-else class="p-4">
      <p>You've selected an area with no official avalanche forecasts - please move or zoom out the map to show a forecast region.</p>
    </div>
  </div>
</template>

<script>
  import RiskPill from '../risk-pill/RiskPill';
  import Tile from 'vue-tile-component';
  import moment from 'moment';

  export default {
    components: {
      RiskPill,
      Tile,
    },

    props: {
      regions: {
        type: Array,
      },

      selectedRegion: {
        type: Number,
      },

      expanded: {
        type: Boolean,
        default: true,
      },

      currentFilter: {
        type: String,
      },

      currentFilterOrder: {
        type: String,
      },

      onTileClick: {
        type: Function,
      },
    },

    computed: {
      sortedRegions() {
        return this.regions.sort((a, b) => {
          let order = 0;

          switch (this.currentFilter) {
            case 'dangerRating':
              const ratingA = this.$store.getters.regionDangerRating(a.id).rating;
              const ratingB = this.$store.getters.regionDangerRating(b.id).rating;

              if (ratingA < ratingB) {
                order = this.currentFilterOrder === 'ASC' ? 1 : -1;
              }
              if (ratingA > ratingB) {
                order = this.currentFilterOrder === 'ASC' ? -1 : 1;
              }
              break;

            case 'lastUpdated':
              const forecastA = this.$store.getters.forecastByRegion(a.id);
              const forecastB = this.$store.getters.forecastByRegion(b.id);
              const lastEditedA = forecastA ? new Date(forecastA.lastEdited) : 0;
              const lastEditedB = forecastB ? new Date(forecastB.lastEdited) : 0;

              if (lastEditedA < lastEditedB) {
                order = this.currentFilterOrder === 'ASC' ? 1 : -1;
              }
              if (lastEditedA > lastEditedB) {
                order = this.currentFilterOrder === 'ASC' ? -1 : 1;
              }
              break;

            default:
              // North to south.
              const aSort = parseInt(a.sortOrder, 10);
              const bSort = parseInt(b.sortOrder, 10);

              if (aSort < bSort) {
                order = this.currentFilterOrder === 'ASC' ? -1 : 1;
              }
              if (aSort > bSort) {
                order = this.currentFilterOrder === 'ASC' ? 1 : -1;
              }
          }

          return order;
        });
      },

      tileWrapperStyles() {
        return (index) => {
          return {
            'col-12': true,
            'col-lg-4': this.expanded,
            'col-xl-3': this.expanded,
            'p-1': true,
            'pr-md-0': !this.expanded,
            'even': (index + 1) % 2 === 0,
          };
        };
      },

      tileStyles() {
        return (region) => {
          return {
            [`tile--danger-${this.$store.getters.regionDangerRating(region.id).rating}`]: true,
            'tile--selected': this.selectedRegion === region.id,
          };
        };
      },

      showTileIcon() {
        return (region) => {
          return this.$store.getters.regionDangerRating(region.id).rating >= 3;
        };
      },
    },

    methods: {
      handleTileClick(id) {
        return (event) => {
          this.onTileClick(event, id);
        }
      },

      lastUpdatedTimeAgo(id) {
        const forecast = this.$store.getters.forecastByRegion(id);

        if (!forecast) {
          return '-';
        }

        const m = moment(forecast.lastEdited);
        return m.from(moment());
      },
    },
  };
</script>
